import React from "react";
import { useConfig } from "../../data/useConfig";
import {
  FilterOptionSkeleton,
  FiltersSkeletonContainer,
  HorizontalFilterSkeleton,
} from "./styles";

const HORIZONTAL = "horizontal";
const SECTIONS = [11, 10, 9];
const getRandomWidth = () => `${Math.random() * (75 - 50) + 50}%`;

const FiltersSkeleton = () => {
  const { filterDirection } = useConfig();

  if (filterDirection === HORIZONTAL) {
    return (
      <FiltersSkeletonContainer className="bnly-filters-skeleton-container">
        <HorizontalFilterSkeleton />
      </FiltersSkeletonContainer>
    );
  }

  return (
    <FiltersSkeletonContainer className="bnly-filters-skeleton-container">
      {SECTIONS.map((count, i) => (
        <div
          key={`filters-skeleton-section-${i}`}
          className="bnly-filter-skeleton-section"
        >
          <div className="bnly-filter-name-skeleton" />
          {Array.from({ length: count }).map((_, index) => (
            <FilterOptionSkeleton key={index} width={getRandomWidth()} />
          ))}
        </div>
      ))}
    </FiltersSkeletonContainer>
  );
};

export default FiltersSkeleton;
